import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type SectionTemplateVersions as SchemaSectionTemplateVersions } from '../schemas/SectionTemplateVersions';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags SectionTemplate
 */
export const GetSectionTemplateVersionsContentType = '' as const;
export type GetSectionTemplateVersionsRequest = void;
export type GetSectionTemplateVersionsResponses = LinkCommonErrorResponses & {
    /**
     * @description List of versions for a section template
     */
    '200': {
        'application/json': SchemaSectionTemplateVersions;
    };
    /**
     * @description Section template not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type GetSectionTemplateVersionsResponseSuccess = GetSectionTemplateVersionsResponses['200']['application/json'];
export type GetSectionTemplateVersionsSearchParams = undefined;
export type GetSectionTemplateVersionsPathParameters = {
    id: string;
};
export const GetSectionTemplateVersionsUrl = '/section_template/{id}/versions' as const;
export const GetSectionTemplateVersionsMethod = 'GET' as const;
export const getGetSectionTemplateVersionsUrl = (params: GetSectionTemplateVersionsPathParameters) =>
    GetSectionTemplateVersionsUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GetSectionTemplateVersionsPathParameters) => String(params[param])
    );
